import * as v from 'valibot';
import type { LocationsMapSearch } from '~/types';
import { BaseModel } from '~/models/base-model';
import {
    fieldModelErrors as fErr,
    txtIsRequired
} from '~/constants';

export const LocationsMapSearchSchema = v.object({
    radius: v.pipe(
        v.number(fErr.noEmpty),
        v.minValue(1, `Radius ${txtIsRequired}`)
    ),
    unit: v.pipe(
        v.string(fErr.noEmpty),
        v.minLength(1, `Unit ${txtIsRequired}`)
    ),
    location: v.nullish(v.string()),
    markets: v.nullish(v.string()),
});

export class LocationsMapSearchModel extends BaseModel<LocationsMapSearch> {
    radius = 20;
    unit = 'mi';
    location = '';
    geolocation = null;
    markets: string = '';
}
